import { RegisterProvisionalCompanyWithConnectBoardMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerProvisionalCompanyWithConnectBoardHandler =
  graphql.mutation<RegisterProvisionalCompanyWithConnectBoardMutation>(
    "registerProvisionalCompanyWithConnectBoard",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerProvisionalCompanyWithConnectBoard: true,
        },
      });
    }
  );
